
import _forEach from 'lodash/forEach'
import track from "../../../components/track";

const form = new Vue({
    el: '#CallMeNow_form',
    data() {
        return {
            form: {
                name: '',
                phone: '',
                terms: false,
            },
            default: {
                name: '',
                phone: '',
                terms: false,
            },
            validation: {
                name: 'required',
                phone: 'required',
            },
            errors: {
                name: false,
                phone: false,
                terms: false,
            },
        }
    },
    methods: {
        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'phone'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    if(!phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }

                if(!this.form[key].length){
                    this.errors[key] = true
                    hasErrors = true
                }
            })
            this.errors.terms = false
            if(!this.form.terms){
                this.errors.terms = true
                hasErrors = true
            }
            if(hasErrors)
                return false

            return true
        },

        clearForm() {
            this.form = Object.assign(this.form, this.default);
        },

        submit(){
            if(!this.validateInputs()){
                return false
            }
            track.event({
                eventCategory: "phone",
                eventAction: "callmeback-landing",
                eventLabel: ""
            })
            axios.post(this.$el.action, this.form).then(response => {
                let name = this.form.name;
                this.clearForm();
                window.location.href = "/truca-ara-gracies?name="+name;
            })
                .catch(error => {
                    console.log(error)
                });
        }
    }
});

